import { config } from 'affiny-core/env';
import { handleAsyncStatus } from 'affiny-core/modules/asynchronousState/saga';
import { EAsyncEventTypes } from 'affiny-core/modules/asynchronousState/types';
import { EReflistSubject } from 'affiny-core/modules/reflists/types';
import { selectAccountAttributeElement } from 'affiny-core/redux/selectors/accountSelectors';
import {
  selectReflists,
  selectReflistsKvk,
  selectReflistsLang,
  selectReflistsPlatform,
} from 'affiny-core/redux/selectors/reflistsSelectors';
import isEmpty from 'lodash/isEmpty';
import { all, call, put, select, takeLatest } from 'redux-saga/effects';
import { getReflists } from '../api';
import { EReflistsActionType, getReflistsSuccessAction } from './actions';

export function* getReflistsSaga() {
  const meReflist = yield select(selectReflists, EReflistSubject.ME);
  const platform = yield select(selectReflistsPlatform);
  const reflistKvk = yield select(selectReflistsKvk);
  const userKvk = yield select(selectAccountAttributeElement, 'kvk');
  const reflistLang = yield select(selectReflistsLang);

  // TODO: change reflist in profileCaptureQuestions in redux
  // reflist is stored in localStorage at the first api call
  // there are 4 reflist (FM, MF, FF, MM)
  // for our needs (profile capture questions) reflist is different between WAM and WAD
  // so we compare the platform and kvk stored with reflist in localStorage
  // with the current platform and the current kvk user.
  if (
    !isEmpty(meReflist) &&
    platform === config.env.platform &&
    reflistKvk === userKvk &&
    reflistLang === config.env.locale
  ) {
    return;
  }

  const response = yield call(getReflists);

  yield put(getReflistsSuccessAction(response));
}

export function* reflistsRootSaga() {
  yield all([
    takeLatest(
      EReflistsActionType.GET,
      handleAsyncStatus(getReflistsSaga, EAsyncEventTypes.REFLISTS_GET)
    ),
  ]);
}
